@if (renderAs === 'icon') {
  <span [class]="statusClass()">
    <mat-icon [title]="statusText">
      {{ statusIcon() }}
    </mat-icon>
  </span>
} @else {
  <span [class]="statusClass()"></span> {{isNil(statusText) ? '' : statusText | translate}}
}

